import React from "react";
import { RightDiv } from "./styles";

const MainBody = ({children, style}) => {
    return (
        <RightDiv style={style}>{children}</RightDiv>
    )
}

export default MainBody;